import {Injectable, TemplateRef} from '@angular/core';
import {ComponentType} from '@angular/cdk/overlay';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import {NewRequestComponent} from '../../requests/components/new-request/new-request.component';
import {RequestNameFormComponent} from '../../requests/components/request-name-form/request-name-form.component';
import {ConfirmCloseModalComponent} from '../../requests/components/request-types/card-production/po-sow/confirm-close-modal/confirm-close-modal.component';
import {
  ApprovalManagerComponent,
  ApprovalManagerConfig
} from '../components/approval-manager/approval-manager/approval-manager.component';
import { RequestTypeModel } from '../../requests/models/request-type.model';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(private dialog: MatDialog) { }

  openDialogs(): MatDialogRef<any, any>[] {
    return this.dialog.openDialogs;
  }

  public openNewRequestModal(requestTypes: RequestTypeModel[]): Observable<{ redirect: boolean; name: string; type: string }> {
    return this.openModal<NewRequestComponent, any, RequestTypeModel>(
      NewRequestComponent, { requestTypes }, undefined, undefined, true,
    )
      .afterClosed()
      .pipe(
        filter(v => !!v),
        switchMap(({ type }) =>
          this.openRequestNameModal(undefined, type).pipe(
            map(value => ({ ...value, type })),
          )),
      );
  }

  public openRequestNameModal(name?: string, type?: string): Observable<{ redirect: boolean; name: string }> {
    return this.openModal<RequestNameFormComponent, any, { redirect: boolean; name: string }>(
      RequestNameFormComponent, { name, type }, undefined, false, true,
    )
      .afterClosed()
      .pipe(filter(v => !!v.name || v.redirect));
  }

  public openConfirmationModal(
    header: string,
    message: string,
    confirmBtn?: string,
    closeBtn?: string,
    shouldHideConfirmBtn?: boolean,
  ): MatDialogRef<ConfirmCloseModalComponent, boolean> {
    return this.openModal(ConfirmCloseModalComponent, { header, message, confirmBtn, closeBtn, shouldHideConfirmBtn });
  }

  public openCloseModal(header: string, message: string): MatDialogRef<ConfirmCloseModalComponent> {
    return this.openModal(ConfirmCloseModalComponent, { header, message, isCloseModal: true });
  }

  public openApprovalManager(approvalManagerConfig: ApprovalManagerConfig): MatDialogRef<ApprovalManagerComponent> {
    const config = new MatDialogConfig();
    config.disableClose = false;
    config.autoFocus = true;
    config.panelClass = 'am-modal';
    config.backdropClass = 'am-modal-backdrop';
    config.position = {top: '0px'};
    config.maxWidth = '';
    config.data = {...approvalManagerConfig};
    return this.dialog.open<ApprovalManagerComponent, ApprovalManagerConfig, boolean|null>(ApprovalManagerComponent, config);
  }

  public openModal<T = any, D = any, R = any>(
      template: TemplateRef<T> | ComponentType<T>,
      data?: D,
      dialogClass?: string,
      autofocus: boolean = true,
      hasBackdrop: boolean = true,
      extra?: Partial<MatDialogConfig>
  ): MatDialogRef<T, R> {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.autoFocus = autofocus;
    config.hasBackdrop = hasBackdrop;
    config.panelClass = dialogClass;
    if (extra) {
      Object.assign(config, extra);
    }
    config.data = {...data};

    return this.dialog.open<T, D, R>(template, config);
  }
}
